<template>
  <PopupModal :open="open" @close="close">
    <template #header>
      <p class="textHeadline3">
        {{ $t("more.delete.userProfile.title") }}
      </p>
    </template>
    <template #body>
      <p
        class="textBody1"
        v-html="$t('more.delete.userProfile.normalDescription')"
      ></p>
      <div v-if="isDeletedProfile" class="text-green-500">
        {{ $t("more.delete.userProfile.success") }}
      </div>
    </template>
    <template #footer>
      <div class="flex flex-row justify-center">
        <ButtonElement
          class="mr-4"
          :label="$t('custom.challenge.track.progress.negative.button.caption')"
          :disabled-visible="true"
          @click="close"
        />
        <ButtonElement
          :label="$t('more.delete.userProfile.delete.button')"
          @click="confirmDeletion"
        />
      </div>
    </template>
  </PopupModal>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
import { useRouter } from "vue-router";
import PopupModal from "../layout/PopupModal.vue";
import { deleteProfile } from "~/api/user";
import ButtonElement from "../form/ButtonElement.vue";
import { getCurrentInstance } from "vue";

const props = defineProps<{
  open: boolean;
}>();

const emit = defineEmits(["close"]);

const isDeletedProfile = ref<boolean>(false);
const router = useRouter();
const { appContext } = getCurrentInstance()!;
const userAuthenticator = appContext.config.globalProperties.$userAuthenticator;

watch(
  () => props.open,
  (val) => {
    if (val) {
      isDeletedProfile.value = false;
    }
  }
);

function close() {
  emit("close");
}

async function confirmDeletion() {
  try {
    await deleteProfile();
    isDeletedProfile.value = true;
    await logoutUser();
  } catch (error) {
    await logoutUser();
  }
}

async function logoutUser() {
  isDeletedProfile.value = true;
  await new Promise((res) => setTimeout(res, 2000));
  userAuthenticator.logout();
  router.push({ name: "login" });
}
</script>
